import { gql } from "apollo-boost";

export const CREATE_PRODUCT_VARIANT = gql`
  mutation CreateProductVariant($data: ProductVariantInput!) {
    createProductVariant(data: $data) {
      product {
        name
        _id
      }
      amount
      originPrice
      price
      currency
      attributeValues {
        id
        value
        attribute {
          name
        }
      }
    }
  }
`;

export const CREATE_PRODUCT_VARIANT_MANY = gql`
mutation CreateProductVariantMany($data: [ProductVariantInput!]!) {
  createProductVariantMany(data: $data) {
    status
    total
    msg
    data {
      id
      product {
        name
      }
    }
  }
}
`

export const UPDATE_PRODUCT_VARIANT = gql`
  mutation UpdateProductVariant(
    $data: ProductVariantInput!
    $where: ProductVariantWhereInputOne!
  ) {
    updateProductVariant(data: $data, where: $where) {
      product {
        name
        _id
      }
      amount
      originPrice
      price
      currency
      attributeValues {
        id
        value
        attribute {
          name
        }
      }
    }
  }
`;

export const UPDATE_PRODUCT_VARIANT_MANY = gql`
  mutation UpdateProductVariantMany(
    $data: ProductVariantInput!
    $where: ProductVariantWhereInputMany!
  ) {
    updateProductVariantMany(data: $data, where: $where) {
      count
    }
  }
`;

export const DELETE_PRODUCT_VARIANT = gql`
mutation DeleteProductVariant($where: ProductVariantWhereInputOne!) {
  deleteProductVariant(where: $where) {
    msg
    status
    data {
      id
    }
  }
}
`
